var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLanguage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4516 0H6.19355V2.57732H8.25806V3.60825H1.54839C0.670968 3.60825 0 4.27835 0 5.15464V10.8247C0 11.701 0.670968 12.3711 1.54839 12.3711H2.06452V15L5.31613 12.3711H8.77419V8.76289H14.4516C15.329 8.76289 16 8.09278 16 7.2165V1.54639C16 0.670103 15.329 0 14.4516 0ZM5.57419 10.2577L5.31613 9.43299H3.71613L3.40645 10.2577H2.16774L3.87097 5.6701H5.10968L6.8129 10.2577H5.57419ZM13.4194 6.18557V7.2165C12.7484 7.2165 12.0258 7.01031 11.4065 6.70103C10.7871 7.01031 10.0645 7.16495 9.34194 7.2165L9.29032 6.18557C9.65161 6.18557 10.0129 6.13402 10.3742 6.03093C9.90968 5.56701 9.6 5 9.44516 4.38144H10.529C10.6839 4.84536 10.9935 5.20619 11.3548 5.51546C11.9226 5.05155 12.2839 4.38144 12.3355 3.60825H9.23871V2.57732H10.7871V1.54639H11.8194V2.57732H13.5226L13.5742 3.09278C13.6258 4.17526 13.2129 5.25773 12.4387 6.03093C12.8 6.13402 13.1097 6.18557 13.4194 6.18557Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/language.318d791ff8a755bbece6735dcc938a2f.svg";
export { ForwardRef as ReactComponent };